import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils.js";
import { QUIZ_BUTTON_STYLES } from "./quiz-styles.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
import Loader2 from "../../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/loader-2.js";
import Check from "../../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/check.js";
function SubmitButton({
  onClick,
  disabled = false,
  isLoading = false,
  label,
  className
}) {
  const { t } = useTranslation("quiz");
  const buttonLabel = label ?? t("common.checkAnswer");
  return /* @__PURE__ */ jsx(
    motion.div,
    {
      initial: { opacity: 0, y: 10 },
      animate: { opacity: 1, y: 0 },
      className: cn("mt-6 flex justify-end", className),
      children: /* @__PURE__ */ jsxs(
        "button",
        {
          onClick,
          disabled: disabled || isLoading,
          className: cn(
            "inline-flex items-center justify-center py-3 px-6 text-lg font-bold rounded-xl transition-all",
            disabled ? QUIZ_BUTTON_STYLES.primaryDisabled : QUIZ_BUTTON_STYLES.primary
          ),
          children: [
            isLoading ? /* @__PURE__ */ jsx(Loader2, { className: "w-5 h-5 animate-spin mr-2" }) : /* @__PURE__ */ jsx(Check, { className: "w-5 h-5 mr-2" }),
            buttonLabel
          ]
        }
      )
    }
  );
}
export {
  SubmitButton
};
//# sourceMappingURL=submit-button.js.map
